
import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Container } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import BarChartIcon from '@mui/icons-material/BarChart';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import WarningIcon from '@mui/icons-material/Warning';
import LogoutIcon from '@mui/icons-material/Logout';

// Feature Flag
const ENABLE_RISK_ANALYSIS = process.env.REACT_APP_ENABLE_RISK_ANALYSIS === 'true';
const ENABLE_AUTH = process.env.REACT_APP_ENABLE_AUTH === 'true';

const Layout = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';

    const menuItems = [
        { text: 'Home', icon: <DashboardIcon />, path: '/' },
        { text: 'Upload Data', icon: <UploadFileIcon />, path: '/upload' },
        { text: 'Groupings', icon: <GroupWorkIcon />, path: '/groupings' },
        { text: 'Analysis', icon: <BarChartIcon />, path: '/analysis' },
        { text: 'Compare', icon: <CompareArrowsIcon />, path: '/compare' },
    ];

    if (ENABLE_RISK_ANALYSIS) {
        menuItems.push({ text: 'Risk Analysis', icon: <WarningIcon />, path: '/risk-analysis' });
    }

    const handleLogout = () => {
        localStorage.removeItem('isAuthenticated');
        navigate('/login');
    };

    if (location.pathname === '/login') {
        return <>{children}</>;
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        Supplier Management v1.6.5
                    </Typography>
                    {(isAuthenticated || !ENABLE_AUTH) && (
                        <>
                            {menuItems.map((item) => (
                                <Button
                                    key={item.text}
                                    color="inherit"
                                    onClick={() => navigate(item.path)}
                                    startIcon={item.icon}
                                >
                                    {item.text}
                                </Button>
                            ))}
                            {ENABLE_AUTH && (
                                <Button color="inherit" onClick={handleLogout} startIcon={<LogoutIcon />}>Logout</Button>
                            )}
                        </>
                    )}
                </Toolbar>
            </AppBar>
            <Container component="main" maxWidth={false} sx={{ mt: 4, mb: 4, flexGrow: 1 }}>
                {children}
            </Container>
        </Box>
    );
};

export default Layout;
